/* ================================================================
   AISTROWISE — Money page behaviour (no libraries)
   1. Buy rail (desktop) + sticky bottom bar (mobile) mirror the tier
      that is in view; default = the recommended tier.
   2. Example-report modal open/close (theme-style).
   ================================================================ */
(function () {
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function initMoney(root) {
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-aw-tier]'));
    if (!tiers.length) return;

    var railTier = root.querySelectorAll('[data-aw-rail-tier]');
    var railPrice = root.querySelectorAll('[data-aw-rail-price]');
    var railChip = root.querySelectorAll('[data-aw-rail-chip]');
    var railVariant = root.querySelectorAll('[data-aw-rail-variant]');
    var railCta = root.querySelectorAll('[data-aw-rail-cta]');
    var bar = root.querySelector('[data-aw-stickybar]');

    var def = root.querySelector('[data-aw-tier][data-recommended="true"]') || tiers[0];

    function apply(tier) {
      var label = tier.getAttribute('data-label') || '';
      var price = tier.getAttribute('data-price') || '';
      var chip = tier.getAttribute('data-chip') || '';
      var variant = tier.getAttribute('data-variant') || '';
      var ev = tier.getAttribute('data-event') || '';
      // «Recomendada» con la misma regla que el Liquid (el ajuste recommended del bloque), para que
      // la etiqueta no cambie al cargar. La única lectura desde el 27-oct no lo lleva.
      var rec = tier.getAttribute('data-recommended') === 'true';
      each(railTier, function (el) { el.textContent = label + (rec ? ' · Recomendada' : ''); });
      // data-price ya no es texto pelado: lleva el marcado que renderiza el tema
      // (aw-price + su etiqueta ISO), escapado en Liquid al escribir el atributo.
      // innerHTML para que el código de moneda viaje pegado a la cifra.
      each(railPrice, function (el) { if (price) el.innerHTML = price; });
      each(railChip, function (el) { if (chip) el.textContent = chip; });
      each(railVariant, function (el) { if (variant) el.value = variant; });
      each(railCta, function (el) { if (ev) el.setAttribute('data-aw-event', ev); });
    }

    // Rail + sticky bar are pinned to the recommended tier (always shown);
    // they no longer mirror whichever tier scrolls into view, per design.
    apply(def);

    if (bar) {
      var onScroll = function () {
        bar.classList.toggle('is-show', window.scrollY > window.innerHeight * 0.6);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initSpec(root) {
    // Vista del bloque de páginas de ejemplo (2026-09-05): una vez por carga, al 50 %
    // de visibilidad, con el prefijo de la calculadora de la landing (astro_ casa con
    // el trigger vivo de GTM). Sin parámetros: solo estructura.
    var excerpt = root.querySelector('[data-aw-sample-strip]');
    var calc = root.getAttribute('data-aw-calc') || '';
    if (excerpt && calc && 'IntersectionObserver' in window) {
      try {
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting && entries[i].intersectionRatio >= 0.5) {
              io.disconnect();
              if (window.awTrack) window.awTrack(calc + '_excerpt_view');
              break;
            }
          }
        }, { threshold: 0.5 });
        io.observe(excerpt);
      } catch (e) {}
    }
    var bar = root.querySelector('[data-aw-spec-stickybar]');
    if (!bar) return;
    var buy = root.querySelector('[data-aw-spec-buy]');
    var lastShown = null;
    var settle = 0;
    function update() {
      // Show the mobile purchase bar whenever the main buy button is off-screen.
      // The mobile hero has no primary CTA and the buy box sits far down the page,
      // so gate on buy-button visibility only (no scroll-depth threshold): the bar
      // is available from the top and hides only when the real buy box is in view.
      var visible = false;
      if (buy) {
        var r = buy.getBoundingClientRect();
        visible = r.top < window.innerHeight && r.bottom > 0;
      }
      // La franja de continuidad del candado ya lleva precio y botón: mientras
      // esté en pantalla, la barra fija no duplica la llamada a la acción.
      var strip = root.querySelector('[data-aw-spec-handoff]');
      if (!visible && strip && !strip.hidden) {
        var sr = strip.getBoundingClientRect();
        if (sr.bottom > 0 && sr.top < window.innerHeight) visible = true;
      }
      var show = !visible;
      bar.classList.toggle('is-show', show);
      // La burbuja de WhatsApp y el badge de hCaptcha suben por encima de la barra
      // (2026-09-05). La regla body.aw-bar-shown / --aw-bar-h ya existía en el snippet
      // global, pero la publicaban aw-product.js y aw-horoscopo.js y no esta sección: por
      // eso la burbuja se apoyaba sobre el botón de compra de las cinco landings. Solo
      // cuando la barra existe de verdad (en escritorio está display:none y no mueve nada).
      var shown = show && bar.offsetHeight > 0;
      document.body.classList.toggle('aw-bar-shown', shown);
      if (shown) document.documentElement.style.setProperty('--aw-bar-h', bar.offsetHeight + 'px');
      else document.documentElement.style.removeProperty('--aw-bar-h');
      // Revisión 2026-09-05: mientras la franja del candado o la caja de compra están en
      // pantalla la barra cede y la burbuja baja a su sitio base, justo por donde cruza el
      // botón de esa franja o de esa caja al hacer scroll (a 390 px la burbuja ocupa los 40 px
      // derechos del botón). Si el bloque de compra intersecta la burbuja, la burbuja se apaga
      // (opacity 0, sin eventos), la misma técnica que aw-consent-compact con el banner.
      var wa = document.querySelector('.aw-whatsapp');
      var clear = false;
      if (wa && !shown) {
        var wr = wa.getBoundingClientRect();
        if (wr.width > 0) {
          var blocks = [];
          if (strip && !strip.hidden) blocks.push(strip.querySelector('.aw-spec-handoff__buy') || strip);
          if (buy) blocks.push(buy);
          for (var k = 0; k < blocks.length; k++) {
            var kr = blocks[k].getBoundingClientRect();
            if (!(kr.right < wr.left || kr.left > wr.right || kr.bottom < wr.top || kr.top > wr.bottom)) { clear = true; break; }
          }
        }
      }
      document.body.classList.toggle('aw-wa-clear', clear);
      // La burbuja baja con una transición de bottom (.25 s) cuando la barra cede: el último
      // evento de scroll la ve aún a medio camino. Se vuelve a medir cuando termina de moverse.
      if (shown !== lastShown) {
        lastShown = shown;
        clearTimeout(settle);
        settle = setTimeout(update, 320);
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    var waEl = document.querySelector('.aw-whatsapp');
    if (waEl) waEl.addEventListener('transitionend', function () { update(); });
    update();

    // Clic de compra por superficie (handoff | buybox | sticky) al píxel propio: solo
    // estructura {calc, from}. GA4 ya lo recoge aw-analytics.js por data-awp-from sobre
    // el mismo data-aw-event, que no se renombra.
    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-aw-event][data-awp-from]');
      if (!b || !root.contains(b)) return;
      var ev = b.getAttribute('data-aw-event') || '';
      if (!/_buy_click$/.test(ev) || !window.awPublish) return;
      var c = root.getAttribute('data-aw-calc') || '';
      if (!c) return;
      // Ventana 2026-09-05: solo la landing de astro publica. La de sinastría lleva su propia
      // lectura (18-sep) y no estrena flujos a mitad de ventana (addenda 4 del pre-registro).
      if (c !== 'astro') return;
      window.awPublish('compra_click', { calc: c, from: b.getAttribute('data-awp-from') || '' });
    }, true);
  }

  // Cierre del modal con devolución del foco (revisión 2026-09-05): role=dialog aria-modal
  // promete que el foco entra al abrir y vuelve al disparador al cerrar; antes se quedaba en
  // la tarjeta de detrás y Tab recorría la página bajo el modal.
  function closeModal(m) {
    m.hidden = true; document.body.style.overflow = '';
    var op = m._awOpener; m._awOpener = null;
    if (op && op.focus && document.contains(op)) { try { op.focus(); } catch (e) {} }
  }

  ready(function () {
    each(document.querySelectorAll('[data-aw-money]'), initMoney);
    each(document.querySelectorAll('[data-aw-spec]'), initSpec);

    document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('[data-aw-modal-open]');
      if (opener) {
        var mid = opener.getAttribute('data-aw-modal-open');
        var m = document.getElementById(mid);
        if (m) {
          var wasHidden = m.hidden;
          m.hidden = false; document.body.style.overflow = 'hidden';
          m._awOpener = opener;
          var closeBtn = m.querySelector('.aw-exmodal__close');
          if (closeBtn && closeBtn.focus) { try { closeBtn.focus(); } catch (err) {} }
          // Enlace profundo (2026-09-05): el disparador nombra la página del ejemplo
          // que responde (data-aw-modal-page) y la GALERÍA (no window: el panel es
          // overflow hidden) baja hasta esa imagen. Sin página, vuelve al principio.
          // Cada imagen reserva width/height, así que el destino no salta al cargar.
          var page = opener.getAttribute('data-aw-modal-page') || '';
          var gallery = m.querySelector('[data-aw-modal-gallery]');
          if (gallery) {
            var target = page ? document.getElementById(mid + '-p' + page) : null;
            var jump = function () {
              if (!target) { gallery.scrollTop = 0; return; }
              // como mucho 8 px de aire sobre la imagen: menos que el hueco entre figuras, así
              // el pie de la página anterior no asoma cortado por el borde de la galería
              var pad = Math.min(8, parseInt(window.getComputedStyle(gallery).paddingTop, 10) || 0);
              gallery.scrollTop += target.getBoundingClientRect().top - gallery.getBoundingClientRect().top - pad;
            };
            jump();
            if (window.requestAnimationFrame) window.requestAnimationFrame(jump);
          }
          if (wasHidden && window.awTrack) window.awTrack('example_report_open'); // once per open
          // Evento con prefijo astro_ (trigger vivo de GTM) solo en la landing de astro
          // (data-aw-calc en la raíz de la sección). La página va solo por awPublish:
          // los eventos astro_ de GA4 no llevan parámetros. Solo estructura, nunca datos.
          var calcRoot = opener.closest('[data-aw-calc]');
          var calc = calcRoot ? calcRoot.getAttribute('data-aw-calc') : '';
          if (wasHidden && calc === 'astro') {
            if (window.awTrack) window.awTrack('astro_example_open');
            if (window.awPublish) window.awPublish('astro_example_open', { calc: 'astro', page: page });
          }
        }
        return;
      }
      if (e.target.closest && e.target.closest('[data-aw-modal-close]')) {
        var modal = e.target.closest('[data-aw-modal]');
        if (modal) closeModal(modal);
        return;
      }
      // Clic fuera del panel: el objetivo es el propio contenedor. No depende
      // de que el velo exista, que es lo que se rompió con `div:empty` de Dawn.
      if (e.target.matches && e.target.matches('[data-aw-modal]')) closeModal(e.target);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        each(document.querySelectorAll('[data-aw-modal]:not([hidden])'), closeModal);
      }
    });
  });
})();
